import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import loadable from "@loadable/component";

import { ConnectAccountAction } from "../../../redux/actions/authActions";

const Loader = loadable(() => import("../../../components/UI/Loader"));

const DiscordCallback = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		const handleRedirect = async () => {
			const { access_token } = window.location.hash
				.substring(1).split("&")
				.reduce((acc, item) => {
					const [key, value] = item.split("=");
					acc[key] = value;
					return acc;
				}, {});
			
			if (access_token) {
				localStorage.removeItem('discord_connect_account');
				try {
					const userInfo = await axios.get("https://discord.com/api/users/@me", { headers: { Authorization: `Bearer ${access_token}` } });
					const payload = {
						profileImage: "",
						name: userInfo?.data?.global_name,
						verifier: "Discord",
						typeOfLogin: "akedo_social",
						verifierId: userInfo?.data?.id,
						email: userInfo?.data?.email,
						loginType: "discord",
						// The server checks with Discord whom this token belongs to before linking.
						token: access_token,
					};
					// Every visitor has a guest account: link it to Discord. The result (or
					// the error) shows as a message on the home page.
					dispatch(ConnectAccountAction(payload));
					navigate("/");
				} catch (error) {
					console.error("[DiscordCallback] Discord sign-in failed", error?.message);
					navigate("/");
				}
			} else {
				navigate("/");
			}
		}
		handleRedirect();
	}, [dispatch, navigate]);

	return <Loader isTranserent={false} />;
};

export default React.memo(DiscordCallback);